module.exports = __webpack_public_path__ + "static/media/tdsatSuccess.2d1cb764.svg";